export function createComponentStackHash(stack?: string | null): string {
  const s = stack ?? '';
  const hash = s
    .split('')
    .reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) % 1_000_000_007, 0);
  return hash.toString(16);
}
